// From terraform outputs (visitor_record_function_url / visitor_get_function_url)
export const VISITOR_RECORD_URL =
  "https://hk3n3m3g2pmexlhwjyxhhek2he0qhwyv.lambda-url.us-east-1.on.aws/";
export const VISITOR_GET_URL =
  "https://zhzwzjrgxgbetfeokptx2c6hoa0mjflc.lambda-url.us-east-1.on.aws/";
